import { Button } from '@mui/material'

// Imports custom
import { FileManagerList } from 'common'
import { TooltipInformation } from 'common'

const FilesTable = ({useFetchInit}) => {
    
    const {
        //------------- Generales
        //------------- globalStates
        globalStates,
        //------------- Helpers
        Helpers,
        //------------- Formularios
        Forms,
        //------------- FetchData
        FetchData,
        //------------- Actions
        Actions
    } = useFetchInit

    const {FormRequestGlobal:{formState}} = Forms

        
    const {formOpeningMode } = globalStates 

    const {handleClickDeleteDocument} = Actions

    const cellRendererTooltip = (params) => {
        //DESESTRUCTURACIÓN DE DATA PARA MOSTRAR EN TOOLTIP
        const {iddocumento, usuario_creo, fecha_creo, usuario_modifico, fecha_modifico} = params.data
        return(
            <>
                <TooltipInformation 
                    idregistro={iddocumento}
                    usuario_creo={usuario_creo}
                    fecha_creo={fecha_creo}
                    usuario_modifico={usuario_modifico}
                    fecha_modifico={fecha_modifico}
                />
            </>
            
        )
    }

    const cellRendererOptions = (params) => {

        const { iddocumento, document_path, department} = params.data


        if ((formOpeningMode==='EDITABLE') && (department=== 'JURIDICO')) return(

            
            <>
                <Button
                    variant='contained' 
                    size='small' 
                    href={document_path} 
                    target="_blank" 
                    color='success' 
                    style={ { marginRight: '0.4vh' } }> 
                    <i className="fa-solid fa-download" style={{ marginRight: '8px' }}></i> Descargar
                </Button>
                <Button 
                    variant='contained' 
                    size='small' 
                    onClick={() => handleClickDeleteDocument(iddocumento)}  
                    color='error' 
                    style={ { marginRight: '0.4vh' } }  > 
                    <i className="fa-solid fa-trash" style={{ marginRight: '8px' }}></i> Eliminar
                </Button>
                {/* disabled={ (openFormSolicitudMode === 'READONLY') ? true : false } */}
            </>
            
        )

        return (
            <>
                <Button
                    variant='contained' 
                    size='small' 
                    href={document_path} 
                    target="_blank" 
                    color='success' 
                    style={ { marginRight: '0.4vh' } }> 
                    <i className="fa-solid fa-download" style={{ marginRight: '8px' }}></i> Descargar
                </Button>
            </>

        )

        
        
    }

    const columnConfig = [
        // { field: "iddocumento", filter: true },
        { 
            //FIELD PARA TOOLTIP
            headerName: "Info", 
            minWidth: 80,
            maxWidth: 80,
            cellStyle: () => ({
                display: "flex",
                alignItems: "center",
                justifyContent: "center"
            }),
            cellRenderer: cellRendererTooltip
        },
        { field: "document_originalname", headerName: "NOMBRE DEL ARCHIVO", minWidth: 250, filter: true },
        { field: "department", headerName: "DEPARTAMENTO", minWidth: 250, filter: true },
        {
            headerName: "OPCIONES",minWidth: 300,
            cellRenderer: cellRendererOptions
        },
    ]

    
    return (
        //ESTRUCTURA PARA INCLUIR CAJA DE BUSQUEDA
        <div className='content'>
            <FileManagerList
                // datos (listados, individuales)
                rowConfig={formState.files}
                columnConfig={columnConfig}

                // HandleClicks

                // Funciones
            />
        </div>
    )
    
}

export {
    FilesTable
}